var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15450_10679",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15450_10679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20.9974C13.0417 20.9974 12.6493 20.8342 12.3229 20.5078C11.9965 20.1814 11.8333 19.7891 11.8333 19.3307V9.33073C11.8333 8.8724 11.9965 8.48003 12.3229 8.15365C12.6493 7.82726 13.0417 7.66406 13.5 7.66406H21C21.4583 7.66406 21.8507 7.82726 22.1771 8.15365C22.5035 8.48003 22.6667 8.8724 22.6667 9.33073V19.3307C22.6667 19.7891 22.5035 20.1814 22.1771 20.5078C21.8507 20.8342 21.4583 20.9974 21 20.9974H13.5ZM13.5 19.3307H21V9.33073H13.5V19.3307ZM10.1667 24.3307C9.70833 24.3307 9.31597 24.1675 8.98958 23.8411C8.66319 23.5148 8.5 23.1224 8.5 22.6641V10.9974H10.1667V22.6641H19.3333V24.3307H10.1667Z",
    fill: "#717B85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyText);
export default __webpack_public_path__ + "static/media/copy_text.1fdf10a6c9cb5fe01f258ef0684b7ea6.svg";
export { ForwardRef as ReactComponent };